<script setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import InputLabel from "@/Components/InputLabel.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import {reactive} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const emits = defineEmits(['close', 'modify']);

const props = defineProps({
    show: {
        type: Boolean,
        default: true,
    },
    entityId: {
        type: String,
    },
});

const data = reactive({
    influence: null,
})

function closeModal() {
    emits('close');
}

function submitModification() {
    const event = {
        entityId: props.entityId,
        influence: data.influence,
    }
    emits('modify', event);
    emits('close');
}

</script>

<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-10" @close="$emit('close')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="mt-0 sm:mt-8 fixed inset-0 z-10 overflow-y-auto">
                <div class="flex min-h-full items-start justify-center text-center sm:items-center sm:p-4 p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="w-full sm:w-9/12 max-w-lg bg-gray-750 rounded-lg shadow-lg">
                            <!-- Header -->
                            <div class="text-left text-white p-4 border-b border-gray-700">
                                <div class="flex justify-between items-center">
                                    <p class="text-gray-300 font-semibold text-2xl"><strong>Modify Content</strong></p>
                                    <FontAwesomeIcon
                                        :icon="['fas', 'xmark']"
                                        class="mt-1 mr-2 cursor-pointer"
                                        size="lg"
                                        style="color: #ffffff;"
                                        @click="closeModal"
                                    />
                                </div>
                            </div>

                            <!-- Content -->
                            <div class="p-6 bg-gray-700 text-left text-gray-100 rounded-b-lg">
                                <p class="text-gray-400 text-sm mb-4">
                                    <strong>Note:</strong> Changes will be automatically applied and are irreversible.
                                </p>

                                <div class="mb-6">
                                    <InputLabel id="description" for="description" value="Modification (Optional)" class="leading-6"/>
                                    <textarea
                                        id="description"
                                        class="block w-full h-32 pl-4 pt-2 rounded border-0 dark-input mt-1"
                                        v-model="data.influence"
                                        placeholder="What would you like to change?"
                                    />
                                </div>

                                <div class="flex justify-end">
                                    <PrimaryButton @click="submitModification">
                                        Request Modification
                                    </PrimaryButton>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
